<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelGrupoEvento"
    :multiple="isMulti"
    :taggable="isTagabble"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    label="nome"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
    :loading="isLoading"
    :hide-selected="true"
    id="tipoMetodoPagamento"
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado.') }}</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado.') }}</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
    <template slot="tag" slot-scope="{ option }"
      ><span class="badge badge-primary mr-1"
        ><span class="text-truncate mr-1 mb-1">{{ option.nome_secundario || option.nome }}</span
        ><span class="custom__remove badge" @mousedown.prevent.stop="removeOption(option)">x</span></span
      ></template
    >
    <template slot="clear" slot-scope="props">
      <div class="multiselect__clear" @mousedown.prevent.stop="clearAll(props.search)"></div>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: [
    'nameField',
    'esporteSelected',
    'paisSelected',
    'checkTemplateOdd',
    'isRequired',
    'isDisabled',
    'emptyLabel',
    'isMulti',
    'isTagabble',
    'alreadyAdded',
    'includeAll'
  ],

  data() {
    return {
      selected: null,
      options: [],
      value: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'grupo_evento', null);
        return;
      }
      this.$emit('selectChange', 'grupo_evento', e);
    },
    setValue(value) {
      if (this.isTagabble) {
        this.selected = value;
        this.removeOptions(value);
        this.$emit('input', value);
        this.$emit('selectChange', 'grupo_evento', value);
      } else {
        if (value) {
          this.selected = this.options.find((option) => option.id === value.id);
        } else {
          this.selected = this.options.find((option) => option.id === null);
        }
        this.$emit('input', this.selected);
      }
    },
    setOptions(esporteId, paisSelected) {
      this.isLoading = true;
      let filter = ' ';
      filter = `public.tipo_esporte.id=${esporteId}`;
      if (this.checkTemplateOdd) {
        filter += ` AND ${
          JSON.parse(localStorage.info).empresa__id_template_odd
        } = any(select (json_array_elements(templates_odd)::text)::integer)`;
      }

      if (paisSelected) filter += ` and cache.grupo_evento.id_pais=${paisSelected}`;
      filter += ` AND cache.evento.momento_realizacao::date >= 'now'::text::date AND cache.evento.momento_realizacao::date <= ('now'::text::date + 30)`;

      this.$atenaList
        .getGrupoEventos({
          columns: 'id, nome_secundario as nome, id_pais',
          filter: filter,
          related: 'gerencia_grupo_evento:id as id_gerencia_grupo_evento',
          groupBy:
            'cache.grupo_evento.id,cache.grupo_evento.id_pais,public.tipo_esporte.id,cache.grupo_evento.nome_secundario,data_source.esporte.id, gerencia_grupo_evento.id',
          order: 'nome_secundario'
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          if (this.alreadyAdded) {
            this.removeOptions(this.alreadyAdded);
          }
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    },
    labelGrupoEvento({ nome }) {
      return `${nome}`;
    },
    clearAll() {
      this.value = [];
    },
    removeOptions(options) {
      if (!options) {
        return;
      }
      let opt = [];
      this.options.forEach((element) => {
        const el = options.find((el) => el.id === element.id);
        if (!el) opt.push(element);
      });
      this.options = opt;
    },
    removeOption(option) {
      if (!option) return;
      let valueCp = [];
      this.selected.forEach((element) => {
        const el = this.selected.find((el) => el.id === option.id);
        if (el) {
          valueCp = this.selected.filter((elem) => elem.id != el.id);
        }
      });
      this.setValue(valueCp);
      this.options = [option, ...this.options];
    }
  },

  watch: {
    esporteSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions(newVal, this.paisSelected);
        !this.selected ? this.onChange() : null;
      }
    },
    paisSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.esporteSelected) {
          this.setOptions(this.esporteSelected, newVal);
          this.onChange();
        }
      }
    },
    nameField: function (value) {
      if (!value) {
        this.setOptions(this.esporteSelected, value);
      } else {
        this.setValue(value);
      }
    }
  },

  created() {
    if (this.esporteSelected) this.setOptions(this.esporteSelected, this.paisSelected);
  }
};
</script>

<style lang="scss" scoped></style>
